import { Component } from "react"
import dispatchEvent from "../../helpers/dispatch-event"
import { root } from "../../services/Globals"

const noop = () => {}

export default class DeleteAudiotrack extends Component {
  constructor(props) {
    super(props)
    this.initialState = {
      mode: `idle`,
      payload: undefined,
    }
    this.state = this.initialState
  }

  render = () => {
    const {
      state: { mode, payload },
    } = this

    return this.props.children({
      mode,
      payload,
      delete: this.delete,
    })
  }

  delete = () => {
    const {
      arrangementId,
      versionId,
      audioId,
      onSuccess = noop,
      onError = noop,
      onLoading = noop,
    } = this.props

    this.setState(
      previousState => ({
        ...previousState,
        mode: `loading`,
      }),
      onLoading
    )

    return root.wav
      .api({
        method: `delete`,
        url: `/arrangements/${ arrangementId }/versions/${ versionId }/audiotracks/${ audioId }`,
      })
      .then(({ data }) => {
        this.setState(
          previousState => ({
            ...previousState,
            mode: `success`,
            payload: data,
          }),
          () => {
            onSuccess(data)
            dispatchEvent(`update:${ versionId }:audiotracks`)
          }
        )
      })
      .catch(error => {
        this.setState(
          previousState => ({
            ...previousState,
            mode: `error`,
            payload: error,
          }),
          () => onError(error)
        )
      })
  }
}
